<template>
  <div>
    <v-card>
      <div style="margin-top:20px;overflow-y: scroll;height: 430px">
        <v-data-table
          :headers="headers"
          :items="data"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:[`item.serial`]="{ item }">
            <description-form  :key="`inci_${item.serial}`" v-if="isEditDescription" :item="item" />
            <span v-else>{{ item.serial}}</span>
          </template>
          <template v-slot:[`item.network`]="{ item }">
            <v-icon :color="getColor(item.network)">mdi-checkbox-blank-circle</v-icon>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-icon :style="{ 'color' : item.statusColor.color}">{{item.statusColor.icon}}</v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
  import DescriptionForm from './DescriptionForm'
  import utils from '@/services/utils'
  export default {
    components: {
      DescriptionForm
    },
    props: {
      devices: {
        type: Array,
        required: false,
        default: []
      }
    },
    data () {
      return {
        headers: [
          {
            text: '',
            align: 'start',
            value: 'network',
          },
          { text: 'Unit ID', value: 'serial' },
          { text: 'Nombre', value: 'name' },
          { text: '', value: 'status' },
        ],
        data: []
      }
    },
    computed: {
      isEditDescription () {
        return false //process.env.VUE_APP_ENV === 'development'
      },
    },
    watch: {
      devices (newValue) {
        this.data = newValue
      }
    },
    mounted () {
      if (this.devices) this.data = this.devices
    },
    methods: {
      getColor (value) {
        return utils.getColor(value)
      },
      getStatus (value) {
        return utils.getStatus(value)
      }
    },
  }
</script>